const CYRILLIC_TO_LATIN: Record<string, string> = {
  а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'e',
  ж: 'zh', з: 'z', и: 'i', й: 'y', к: 'k', л: 'l', м: 'm',
  н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u',
  ф: 'f', х: 'kh', ц: 'ts', ч: 'ch', ш: 'sh', щ: 'shch',
  ъ: '', ы: 'y', ь: '', э: 'e', ю: 'yu', я: 'ya',
};

/** Транслитерация кириллицы в латиницу + slug: нижний регистр, пробелы/спецсимволы → '-'. */
export function slugifySectionKey(title: string, fallback = 'section'): string {
  const transliterated = Array.from(title.toLowerCase())
    .map((ch) => (ch in CYRILLIC_TO_LATIN ? CYRILLIC_TO_LATIN[ch] : ch))
    .join('');

  const slug = transliterated
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return slug || fallback;
}

/** Гарантирует уникальность key внутри списка секций (section, section-2, section-3...). */
export function uniqueSectionKey(baseKey: string, existingKeys: Set<string>): string {
  if (!existingKeys.has(baseKey)) return baseKey;
  let i = 2;
  while (existingKeys.has(`${baseKey}-${i}`)) {
    i += 1;
  }
  return `${baseKey}-${i}`;
}
